import { configureAppStore } from './configureStore';

export const store = configureAppStore();

export default store;
